// src/components/Service1.js
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Header from "./Header";
import Footer from "./Footer";
import "./Service1.css";

import rainforestImg from "../images/rainforest.jpg";
import mountainImg from "../images/mountain.jpg";
import coastalImg from "../images/coastal.jpg";

const locations = [
  { name: "Rainforest Sanctuary", image: rainforestImg, description: "A lush rainforest filled with exotic birds.", amount: 50 },
  { name: "Mountain Reserve", image: mountainImg, description: "High-altitude reserve for mountain-dwelling birds.", amount: 70 },
  { name: "Coastal Bird Park", image: coastalImg, description: "Observe coastal and migratory birds near the sea.", amount: 60 },
];

function Service1() {
  const navigate = useNavigate();
  const [selectedLocation, setSelectedLocation] = useState(null);
  const [bookingForm, setBookingForm] = useState({ name: "", email: "" });
  const [comments, setComments] = useState([]);
  const [commentMessage, setCommentMessage] = useState("");

  // Load comments from backend
  useEffect(() => {
    const loadComments = async () => {
      try {
        const res = await fetch("http://localhost:5000/api/service1/comments");
        const data = await res.json();
        setComments(Array.isArray(data) ? data : []);
      } catch (err) {
        console.error("Failed to load comments:", err);
      }
    };
    loadComments();
  }, []);

  const handleSelect = (loc) => setSelectedLocation(loc);

  const handleProceedPayment = () => {
    if (!selectedLocation) return alert("Please select a location first!");
    navigate("/payment", { state: { location: selectedLocation } });
  };

  const handleBookingSubmit = async () => {
    if (!selectedLocation) return alert("Please select a location first!");
    if (!bookingForm.name.trim() || !bookingForm.email.trim()) return alert("Enter name and email");

    try {
      const body = {
        name: bookingForm.name.trim(),
        email: bookingForm.email.trim(),
        location: selectedLocation.name,
        amount: selectedLocation.amount,
      };

      const res = await fetch("http://localhost:5000/api/service1/book", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(body),
      });

      if (!res.ok) throw new Error("Booking failed");

      const saved = await res.json();
      alert("Booking saved! Booking id: " + (saved._id || saved.id || ""));
      setBookingForm({ name: "", email: "" });
      setSelectedLocation(null);
    } catch (err) {
      console.error(err);
      alert("Booking failed. See console for details.");
    }
  };

  const handleCommentSubmit = async (e) => {
    e.preventDefault();
    const commenterName = bookingForm.name.trim() || "Guest";
    if (!commentMessage.trim()) return alert("Write a comment first");

    try {
      const body = { name: commenterName, email: bookingForm.email.trim(), message: commentMessage.trim() };

      const res = await fetch("http://localhost:5000/api/service1/comments", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(body),
      });

      if (!res.ok) throw new Error("Failed to post comment");

      const newComment = await res.json();
      setComments((prev) => [newComment, ...(Array.isArray(prev) ? prev : [])]);
      setCommentMessage("");
    } catch (err) {
      console.error("Comment post error:", err);
      alert("Unable to post comment.");
    }
  };

  return (
    <div className="service1-page">
      

      <main className="service1-content">
        <h2>Bird Watching Guides</h2>
        <p>Select a location to watch birds:</p>

        <div className="locations-grid">
          {(locations || []).map((loc) => (
            <div
              key={loc.name}
              className={`location-card ${selectedLocation?.name === loc.name ? "selected" : ""}`}
              onClick={() => handleSelect(loc)}
            >
              <img src={loc.image} alt={loc.name} />
              <h3>{loc.name}</h3>
              <p>{loc.description}</p>
              <p>Amount: ${loc.amount}</p>
            </div>
          ))}
        </div>

        {/* Booking inputs */}
        <div className="booking-row">
          <input
            type="text"
            placeholder="Your Name"
            value={bookingForm.name}
            onChange={(e) => setBookingForm({ ...bookingForm, name: e.target.value })}
          />
          <input
            type="email"
            placeholder="Your Email"
            value={bookingForm.email}
            onChange={(e) => setBookingForm({ ...bookingForm, email: e.target.value })}
          />
          <button className="proceed-btn" onClick={handleBookingSubmit}>
            Book Now & Pay
          </button>
          <button className="proceed-btn ghost" onClick={handleProceedPayment}>
            Go to Payment Page
          </button>
        </div>
      </main>

      {/* Comments */}
      <section className="comments-section">
        <h2>Community Comments</h2>

        <form className="comment-form" onSubmit={handleCommentSubmit}>
          <textarea
            name="comment"
            placeholder="Write your comment..."
            value={commentMessage}
            onChange={(e) => setCommentMessage(e.target.value)}
            required
          />
          <button type="submit">Post Comment</button>
        </form>

        <div className="comment-list">
          {(!comments || comments.length === 0) ? (
            <p className="no-comments">No comments yet. Be the first!</p>
          ) : (
            (comments || []).map((c) => (
              <div key={c._id || c.id} className="comment">
                <div className="comment-header">
                  <div className="avatar">{(c.name || "U").charAt(0).toUpperCase()}</div>
                  <div>
                    <h4>{c.name}</h4>
                    <small>{new Date(c.date || c.createdAt || Date.now()).toLocaleString()}</small>
                  </div>
                </div>
                <p className="comment-text">{c.message}</p>
              </div>
            ))
          )}
        </div>
      </section>


    </div>
  );
}

export default Service1;
